export default __webpack_public_path__ + "static/zoomLogo-24ccefcffea8e35693469b6892a3e8ed.svg";